'use client';

import dynamic from 'next/dynamic';

const MobileSettingStartPage = dynamic(
  () =>
    import('@/widgets/NewLanding').then((mod) => mod.MobileSettingStartPage),
  {
    ssr: false,
  }
);

const SettingPage = () => {
  return <MobileSettingStartPage />;
};

export default SettingPage;
